import axios from 'axios';
import { useMutation } from 'react-query';

export const useGetTenantInfo = () =>
  useMutation('get-tenant-info', (payload) =>
    axios.post(`${process.env.REACT_APP_BACKEND_PORTAL_URL}/tenant/info`, payload).then((res) => res.data),
  );
